import { ReactElement } from "react";
import { UseFormRegisterReturn } from "react-hook-form";

interface Props3 {
    register: UseFormRegisterReturn<string>;
    label: string;
    width: string;
    height: string;
    type?: string;
    datos: ReactElement[];
}

export function SelectCreateEmpresaForm({ register, label, width, height, datos }: Props3) {
    return (
        <div className="grid">
            <label className="text-sm font-semibold">{label}</label>
            <select 
                {...register}
                defaultValue={0}
                className={`${width} ${height} rounded-[3px] border-gray-400 border px-2 
                    font-semibold text-gray-600 text-sm`}>
                <option hidden value={0}>Seleccionar...</option>
                {datos.map((element) => element)}
            </select>
        </div>
    );
}